import React from 'react';
import '../css/PreviewLand.css';

const PreviewLand = ({
  formData,
  stateName,
  district,
  onEdit,
  onConfirm,
  isSubmitting,
  error
}) => {
  const { file, ...rest } = formData;
  const previewUrl = URL.createObjectURL(file);

  return (
    <div className="preview-container">
      <h2>Preview Your Land Details</h2>
      {error && <div className="error-message">{error}</div>}

      <div className="preview-image">
        <img src={previewUrl} alt="Land Preview" />
      </div>

      <ul className="preview-list">
        <li><strong>State:</strong> {stateName}</li>
        <li><strong>District:</strong> {district}</li>
        {Object.entries(rest).map(([key, val]) => (
          <li key={key}>
            <strong>{key.replace(/([A-Z])/g, ' $1')}:</strong> {val}
          </li>
        ))}
      </ul>

      <div className="preview-actions">
        <button onClick={onEdit} disabled={isSubmitting}>Edit</button>
        <button onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Registering...' : 'Confirm & Register'}
        </button>
      </div>
    </div>
  );
};

export default PreviewLand;
